import Cookies from 'js-cookie';
import { addSeconds, differenceInSeconds } from 'date-fns';
import SETTINGS from 'settings';

export const getSeconds = (initialTime: number, timerName: string, dateRight: Date) => {
  const isDevelop = SETTINGS.environment === 'development';
  const seconds = isDevelop && initialTime ? 5 : initialTime;
  const initialDate = addSeconds(dateRight, seconds);
  const cookieDate = Cookies.get(timerName);

  if (!cookieDate) {
    Cookies.set(timerName, initialDate, { expires: !initialTime ? 0 : 30 });
  }

  const dateLeft = cookieDate ? new Date(cookieDate) : initialDate;

  return differenceInSeconds(dateLeft, dateRight);
};
